import { logService, httpLogPlugin, prefixLogPlugin } from '@nsftx/seven-client-retail-utils'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { appRunUuidStorage } from '@nsftx/seven-client-retail-utils'
import { vueDmCoreConfigPlugin } from '@nsftx/seven-client-retail-vue-dm-core'
import { useDeviceManagementStore } from '@nsftx/seven-client-retail-vue-dm'
import { createIntegratorPlugin } from '@nsftx/seven-client-retail-vue-integrator'
import {
  createRetailSdkPlugin,
  vNxgRetailFormatNumber,
  vShortcut,
} from '@nsftx/seven-nxg-retail-vue-sdk'

import App from './ui/components/App.vue'
import translationsPlugin from './plugins/translationsPlugin'
import router from './router'
import { registerGuards } from '@/router/guards'
import {
  createSevenIgamingPlatformPlugin,
  indexedDbDriver,
} from '@nsftx/seven-client-retail-vue-sgp'

const urlParams = new URLSearchParams(window.location.search)
const urlLogLevel = urlParams.get('logLevel')
const appRunUuid = urlParams.get('appRunUuid') || ''
const lsLogLevel = localStorage.getItem('ss.logLevel')

appRunUuidStorage.setAppRunUuid(appRunUuid)

if (import.meta.env.PROD) {
  // set log level -> query param -> local storage -> default INFO
  logService.setLogLevel(urlLogLevel?.toUpperCase() || lsLogLevel?.toUpperCase() || 'INFO')
  // register http plugin that sends logs to grape
  logService.registerPlugin(httpLogPlugin.apply, {
    apiUrl: import.meta.env.VITE_GRAPE_API_URL,
    user: import.meta.env.VITE_GRAPE_API_AUTH_USER,
    pass: import.meta.env.VITE_GRAPE_API_AUTH_PASS,
    appName: 'POS',
    channel: 'POS', // so grape accepts request, change later to pos
  })
}
// register log prefix plugin (always)
logService.registerPlugin(prefixLogPlugin.apply)

const app = createApp(App)

app.use(createPinia())
app.use(createRetailSdkPlugin({ channel: 'pos' }))
app.use(router)
app.use(translationsPlugin)
app.use(vueDmCoreConfigPlugin, {
  appName: 'pos',
  getTenantUuid: () => useDeviceManagementStore().appData?.betshop.companyUuid ?? '',
  getDeviceUuid: () => useDeviceManagementStore().appData?.device.uuid ?? '',
})
app.use(createSevenIgamingPlatformPlugin, {
  token: null,
  notificationService: {
    events: ['ng::slip-update'],
  },
  slipsStorageDriver: indexedDbDriver,
})
app.use(createIntegratorPlugin({ type: 'pos' }))

app.directive('shortcut', vShortcut)
app.directive('nxg-retail-format-number', vNxgRetailFormatNumber)

registerGuards()

app.mount('#app')
